<!-- 企业设置 -->
<template>
  <div class='tab-company-manage'>
    <el-form ref="form" :model="form" label-width="100px" label-position="left" style="width:780px;" :rules="formRules"
      :validate-on-rule-change="false">
      <el-row>
        <el-form-item label="企业名称:" prop="name">
          <el-autocomplete style="width: 100%" placeholder="请输入" clearable v-model="form.name"
            :fetch-suggestions="querySearch" :trigger-on-focus="false"></el-autocomplete>
        </el-form-item>
        <el-form-item label="地区:" required>
          <el-input v-model="form.showname"></el-input>
        </el-form-item>
        <el-form-item label="企业图标:">
          <el-upload ref="upload" size="small" style="width:100px;height:100px;" :auto-upload="false"
            :on-change="imgPreview" class="avatar-uploader" :action="upload.postURL" :show-file-list="false">
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon" style="width:100px;height:100px;line-height: 100px"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="企业管理员:">
          <el-select v-model="company" filterable multiple placeholder="请选择企业管理员">
            <el-option v-for="item in companyManages" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="硬件绑定:" required>
          <el-switch v-model="isbinding" active-color="#F66B3D" :active-value="1" :inactive-value="0"
            inactive-color="#F6F6F6">
          </el-switch><span style="padding-left:10px;color:#666666">是否启用硬件绑定</span>
        </el-form-item>
        <el-form-item label="客户地址:" required prop="address">
          <GisCommon ref="GisCommon" :selected="selected" :address.sync="form.address" @backPram="backPram"
            v-model="form.address">
          </GisCommon>
        </el-form-item>


        <el-col :span="12">
          <el-form-item label="大区代号:">
            <el-select v-model="form.regionCode" placeholder="请选择" style="width:200px" :disabled="loginType != '1'">
              <el-option v-for="item in regionCodeList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="资质等级:" prop="grade">
            <el-select v-model="form.grade" placeholder="请选择" style="width:200px">
              <el-option v-for="item in gradeList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="企业性质:" prop="natrue">
            <el-select v-model="form.natrue" placeholder="请选择" style="width:200px">
              <el-option v-for="item in natureList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="用户规模:" prop="userScale">
            <el-input v-model="form.userScale" placeholder="请输入" auto-complete="off" style="width:200px"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="企业联系人:" prop="linker">
            <el-input v-model="linker" placeholder="请输入" auto-complete="off" style="width:200px"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="联系方式:" prop="linkerPhone">
            <el-input v-model="linkerPhone" placeholder="请输入" auto-complete="off" style="width:200px"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="客户经理:">
            <SelectCommon placeholder="客户经理" :clearable="true" apiPath="/tbAdminuser/manageList"
              :disabled="loginType !== '1'" :keys="{ label: 'name', value: 'id' }" :defaultVal="managerAdminuser"
              @change="(value, datas) => handleSelectCommonFilter(value, datas, 'managerAdminuser')" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="客户成功经理:">
            <SelectCommon placeholder="请选择客户成功经理" style="width: 200px" class="kuang" :clearable="true"
              apiPath="/tbAdminuser/list" :params="{ type: 3 }" :keys="{ label: 'name', value: 'id' }"
              :disabled="loginType !== '1'"
              :defaultVal="successfulManager" @change="
                (value, datas) =>
                  handleSelectCommonFilter(value, datas, 'successfulManager')
              " />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="经销商:">
            <SelectCommon placeholder="请选择经销商" style="width: 200px" class="kuang" :clearable="true"
              apiPath="/tbAdminuser/list" :params="{ type: 4 }" :keys="{ label: 'name', value: 'id' }"
              :disabled="loginType !== '1'"
              :defaultVal="agencyManager" @change="
                (value, datas) =>
                  handleSelectCommonFilter(value, datas, 'agencyManager')
              " />
          </el-form-item>
        </el-col>


        <el-col :span="12" v-if="editLevel">
          <el-form-item label="客户分级:" prop="level" class="ratingClass">
            <el-rate v-model="form.level" :max="3" style="margin-top:10px"></el-rate>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注:">
            <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="note">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="footer">
      <el-button style="background:#F66B3D;color:#FFF;width:140px;" @click="saveData">保存设置</el-button>
    </div>
  </div>
</template>

<script>
import { API__code, API_User, API_Common } from '../../../api/index.js'
import { mapGetters } from 'vuex'
import GisCommon from '@/components/GisCommon'
import SelectCommon from '@/components/SelectCommon'

import axios from 'axios'
export default {
  props: {
    editLevel: {
      type: Boolean,
      default: true
    }
  },

  data() {
    // 校验企业名称是否唯一
    var validatorCompany = async (rule, value, callback) => {
      if (!this.form.name) {
        callback("请输入企业名称")
      } else {
        if (this.oldname != value) {
          let res = await this.checkCompanyFun(this.form.name);
          !res ? callback('企业名称已存在') : callback();
        }

      }
    }
    let validatorAddress = async (rule, value, callback) => {
      if (!this.form.address) {
        callback("请输入企业位置")
      } else {
        if (!this.position_) {
          callback('请在GIS地图中确认位置')
        } else {
          callback();
        }
      }
    }
    return {
      loginType: sessionStorage.getItem('type'),
      oldname: '',
      form: {
        name: '',
        showname: '',
        grade: '',
        userScale: '',
        natrue: '',
        regionCode: '',
        address: '',
        level: 0,
      },
      beformAddImg: '',
      imageUrl: '',
      editImageUrl: '',
      upload: {
        fileList: this.fileList,
        picIds: [],
        postURL: API_Common.setCompanyPic(), //post地址
        dialogImageUrl: '', // 文件地址
        dialogVisible: false, // 上传文件loading
        data: {
          mode: 'save',
          token: this.token,
          checkCode: this.checkCode,
          type: 1,
        },
      },
      token: '',
      checkCode: '',
      id: '',
      adminuserlist: [], //客户经理列表
      adminuser: '', //客户经理
      companyManages: [], //企业管理员列表
      company: '', //企业管理员
      isbinding: 1,
      selected: { province: '320000', city: '320100', area: '320115', town: '320115010' }, // ['110000', '130200', '140100']
      address: '',
      selected_: '',
      address_: '',
      token: '',
      checkCode: '',
      id: '',
      position_: '',

      comLists: [],
      oldCompanyName: '', // 公司名称备份
      regionCode: '1',
      regionCodeList: [
        {
          value: "1",
          label: "华东大区",
        },
        {
          value: "2",
          label: "华北大区",
        },
        {
          value: "3",
          label: "西北大区",
        },
        {
          value: "4",
          label: "华南大区",
        },
        {
          value: "5",
          label: "西南大区",
        },
      ],
      gradeList: [
        {
          value: "1",
          label: "综合甲",
        },
        {
          value: "2",
          label: "公路甲",
        },
        {
          value: "3",
          label: "市政甲",
        },
        {
          value: "4",
          label: "公路市政甲",
        },
        {
          value: "5",
          label: "公路乙",
        },
        {
          value: "6",
          label: "市政乙",
        },
        {
          value: "7",
          label: "公路市政乙",
        },
        {
          value: "9",
          label: "高校",
        },
        {
          value: "10",
          label: "施工单位",
        },
        {
          value: "8",
          label: "其他",
        },
      ],
      natureList: [
        {
          value: '1',
          label: '央企',
        },
        {
          value: '2',
          label: '国企',
        },
        {
          value: '3',
          label: '民营上市',
        },
        {
          value: '4',
          label: '民营',
        },
        {
          value: "5",
          label: "高校",
        },
      ],
      linker: '',
      linkerPhone: '',
      managerAdminuser: "",
      successfulManager:"",
      agencyManager:"",
      note: '',
      formRules: {
        name: [
          { required: true, validator: validatorCompany, trigger: 'blur' },
        ],
        // regionCode: [{ required: true, message: '请选择大区代号', trigger: 'change' }],
        grade: [{ required: true, message: '请选择资质等级', trigger: ['change'] }],
        natrue: [{ required: true, message: '请选择企业性质', trigger: ['change'] }],
        userScale: [{ required: true, message: '请输入用户规模', trigger: ['blur', 'change'] }],
        address: [
          { validator: validatorAddress, trigger: ['blur', 'change'] },
        ],
        level: [{ required: true, message: '请选择客户分级', trigger: ['blur', 'change'] }],
        showname: [{ required: true, message: '请输入地区', trigger: ['blur', 'change'] }],

      },
    }
  },

  components: {
    GisCommon,
    SelectCommon
  },

  computed: {
    ...mapGetters({
      userInfo: 'userInfo',
    }),
  },

  mounted() {
    try {
      this.comLists = JSON.parse(sessionStorage.getItem('comLists'))
    } catch (e) {
      // 根据名称模糊查询企业列表
      API_User.getCompanySearch().then((res) => {
        if (res.data.code == API__code.SUCCESS) {
          let data = res.data.data
          this.comLists = data.map((item) => ({ value: item }))
          sessionStorage.setItem('comLists', JSON.stringify(this.comLists))
        } else {
          this.$message.error(res.data.message)
          if (res.data.code == 403) {
            this.$router.push({ path: 'loginAdmin' })
          }
        }
      })
    }
    if (document.cookie.length > 0) {
      var arr = document.cookie.split('; ') //这里显示的格式需要切割一下自己可输出看下
      for (var i = 0; i < arr.length; i++) {
        var arr2 = arr[i].split('=') //再次切割
        //判断查找相对应的值
        if (arr2[0] == 'dnnyptadmin_token') {
          this.token = arr2[1] //保存到保存数据的地方
        } else if (arr2[0] == 'dnnyptadmin_checkCode') {
          this.checkCode = arr2[1]
        } else if (arr2[0] == 'dnnyptadmin_id') {
          this.id = arr2[1]
        }
      }
    }
    let param = {
      token: this.token,
      checkCode: this.checkCode,
      id: this.id,
      companyId: this.$route.query.companyId,
    }
    API_User.getCompanyUser(param).then((res) => {
      this.companyManages = res.data.data
    })
    let paramx = {
      token: this.token,
      checkCode: this.checkCode,
    }
    API_User.allAdminuser(paramx).then((res) => {
      this.adminuserlist = res.data.data
    })
    API_User.getComputeDetail(this.$route.query.companyId).then((res) => {
      this.form.name = res.data.data.name
      this.oldname = res.data.data.name
      this.oldCompanyName = res.data.data.name
      this.form.showname = res.data.data.showname
      this.imageUrl = res.data.data.sltUrl
      // 客户经理登录客户经理默认就是自己
      this.adminuser = this.userInfo.type == 1 ? res.data.data.managerAdminuser : this.userInfo.id
      this.isbinding = res.data.data.isbinding
      this.form.regionCode = res.data.data.regionCode
      this.form.grade = res.data.data.grade
      this.form.natrue = res.data.data.natrue
      this.form.userScale = res.data.data.userScale
      this.linker = res.data.data.linker
      this.linkerPhone = res.data.data.linkerPhone
      this.managerAdminuser = res.data.data.managerAdminuser
      this.agencyManager=res.data.data.agencyManager
      this.successfulManager=res.data.data.successfulManager
      this.form.level = Number(res.data.data.level)
      this.note = res.data.data.note
      if (res.data.data.managerid) {
        this.company = res.data.data.managerid.split(',')
      }
      this.selected = {
        province: res.data.data.province ? JSON.parse(res.data.data.province).key : '',
        city: res.data.data.city ? JSON.parse(res.data.data.city).key : '',
        area: res.data.data.district ? JSON.parse(res.data.data.district).key : '',
        town: '',
      }
      if (res.data.data.longitudeAndLatitude) {
        this.position_ = [
          Number(res.data.data.longitudeAndLatitude.split(',')[0]),
          Number(res.data.data.longitudeAndLatitude.split(',')[1]),
        ]
      }
      this.$refs.GisCommon.changItem(res.data.data.addressInfo)
      this.$refs.GisCommon.changePro(this.selected)
      this.$refs.GisCommon.changePos(this.position_)
      this.form.address = res.data.data.addressInfo,
        this.selected_ = {
          province: res.data.data.province ? JSON.parse(res.data.data.province) : '',
          city: res.data.data.city ? JSON.parse(res.data.data.city) : '',
          district: res.data.data.district ? JSON.parse(res.data.data.district) : '',
          town: null,
        }
      this.$refs.form.clearValidate()

    })
  },

  methods: {
    // 校验公司名称是否唯一：true唯一 false 不唯一
    checkCompanyFun(name) {
      return API_User.checkCompanyUnique({ name })
        .then((res) => {
          if (res.data.code == 401) {
            return false
          }
          return true
        })
        .catch((err) => {
          return true
        })
    },

    // el-autocomplete
    querySearch(queryString, cb) {
      var comLists = this.comLists
      var results = queryString ? comLists.filter(this.createFilter(queryString)) : comLists
      // 调用 callback 返回建议列表的数据
      cb(results)
    },

    createFilter(queryString) {
      return (restaurant) => {
        return restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
      }
    },

    getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ') //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=') //再次切割
          //判断查找相对应的值
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1] //保存到保存数据的地方
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1]
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1]
          }
        }
        this.queryData()
      }
    },

    imgPreview(file, fileList) {
      let fileName = file.name
      let regex = /(.jpg|.jpeg|.gif|.png|.bmp)$/
      if (regex.test(fileName.toLowerCase())) {
        this.beformAddImg = file
        this.imageUrl = URL.createObjectURL(file.raw)
        this.editImageUrl = URL.createObjectURL(file.raw)
      } else {
        this.$message.error('请选择图片文件')
      }
    },

    backPram(param) {
      ; (this.position_ = param.position),
        (this.form.address = param.address),
        (this.selected_ = param.selected)
    },

    async saveData() {
      let param = {
        token: this.token,
        checkCode: this.checkCode,
        mode: '',
        id: this.$route.query.companyId,
        logoid: this.imageUrl,
        managerid: this.company.toString(),
        createUser: this.userInfo.id,
        province: JSON.stringify(this.selected_.province),
        city: JSON.stringify(this.selected_.city),
        district: JSON.stringify(this.selected_.area),
        longitudeAndLatitude: this.position_.toString(),
        addressInfo: this.form.address,
        managerAdminuser: this.managerAdminuser,
        agencyManager:this.agencyManager,
        successfulManager:this.successfulManager,
        isbinding: this.isbinding,
        ...this.form,
        linker: this.linker,
        linkerPhone: this.linkerPhone,
        note: this.note
      }
      this.$refs['form'].validate((valid) => {
        if (valid) {
          // 先上传图片
          if (this.beformAddImg) {
            let formData = new FormData()
            formData.append('pic', this.beformAddImg.raw)
            formData.append('token', this.token)
            formData.append('checkCode', this.checkCode)
            formData.append('mode', 'save')
            let config = {
              'Content-Type': 'multipart/form-data',
            }
            axios
              .post(this.upload.postURL, formData, config)
              .then((res) => {
                if (res.data.code == 200) {
                  let { pic, id } = res.data.data
                  param.logoid = pic
                  param.showpicid = id
                  this.editSave(param)
                  this.$refs.upload.clearFiles()
                } else {
                  this.$message.error(res.data.message)
                  if (res.data.code == 403) {
                    this.$router.push({ path: 'loginAdmin' })
                  }
                  return
                }
              })
              .catch(function (error) {
                console.log(error)
                return
              })
          } else {
            this.editSave(param)
          }
        }
      })



    },

    editSave(param) {
      let paramx = {
        companyid: this.$route.query.companyId,
        userid: this.company.toString(),
        toke: this.token,
        checkCode: this.checkCode,
      }
      API_User.setCompanyManager(paramx).then((res) => {
        if (res.data.code != 200) {
          this.$message.error(res.data.message)
        } else {
          API_User.addCompanyList(param)
            .then((res) => {
              if (res.data.code == 200) {
                this.$message({ message: '编辑成功', type: 'success' })
                this.oldCompanyName == this.form.name
              } else {
                this.$message.error(res.data.message)
              }
            })
            .catch((err) => {
              this.$message.error('数据丢失，试试重新登陆！')
            })
        }
      })
    },

    // 客户经理过滤
    handleSelectCommonFilter(value, datas, key) {
      this[key] = value[0]
    },
  },
}
</script>
<style lang='scss' scoped>
.el-row {
  margin-left: 0 !important;
}

.tab-company-manage {
  padding-top: 20px;
  width: 100%;
  height: 600px;

  .footer {
    padding: 30px 30px 30px 0;
    border-top: 1px solid #EBEBEB;
    width: 96%;
    text-align: right;
  }

  .avatar {
    height: 100px;
    width: 100px;
  }
}
</style>


// WEBPACK FOOTER //
// CompamySetting.vue?8e0e0cea